import React,{useState,useEffect,ChangeEvent} from "react";
import BadgesComponent from "@components/common/Badges";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import './ReferralView.css'
import Button from "@components/common/Button";
import ManageReferralModal from "./ManangeReferralModal";
import { changeReferralStatus, getfacilityReferralStatus, getReferredFromInfoByReferralId, getReferredToInfoByFacilityReferralGroupId } from "../FacilityReferralUtils/FacilityReferralServices";
import { errorLogger } from "@utils/applicationLogUtils";
import { decodeWithKeyAndShift } from '../../../../../utils/base64Utils';
import { useDispatch } from "react-redux";
import { FACILITY_COMMON_CONSTANTS, FACILITY_NAVIGATIONS, STATUS, STATUS_CLASSES } from "../FacilityReferralUtils/FacilityReferralConstants";
import { PagePermission } from "@services/usePermission";
import { MODULE_CODES, PAGE_CODES } from "@constants/moduleAndPageCodes";
import { dateFormate } from "@constants/index";

const ReferralChildView = () => {

    const [showModal,setShowModal] = useState(false);
    const [designation,setDesignation] = useState('');
    const [commentText, setCommentText] = useState('');
    const [fromCommentText,setFromCommentTest] = useState('');
    const [facilityType,setFacilityType] = useState('');
    const [facilityName,setFacilityName] = useState('');
    const [hprId,setHPRId] = useState('');
    const [firstName,setFirstName] = useState('');
    const [lastName,setLastName] = useState('');
    const [referralDate,setReferralDate] = useState('');
    const [referralStatusOptions,setReferralStatusOptions] = useState<any[]>([]);
    const [referredToData,setReferredToData] = useState<any[]>([]);
    const [hideButton,setHideButton] = useState<boolean>(false)
    const [selectedStatusId,setSelectedStatusId] = useState<any>('')

    const userDetails = localStorage.getItem('userDetails');
    const decodedUserData=JSON.parse(decodeWithKeyAndShift(userDetails));
    const canCreateServices = PagePermission(MODULE_CODES.BENEFICIARY_SERVICE, PAGE_CODES.SERVICE_CREATE);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const imageDetails = useSelector(
      (state: RootState) => state.beneficiary.imageData,
    );

    const [beneficiaryDetails] = useSelector(
        (state: RootState) => state.beneficiary.beneficiaryDetails,
      );
    
    const isHRP= useSelector((state: RootState) => state.beneficiary.isHRP);

    const referralMetaData = useSelector((state: RootState) => state.beneficiary.facilityReferralMetaData);
    const childDetails = useSelector((state: RootState) => state.beneficiary.childDetails);
    const isChild = useSelector((state: RootState) => state.beneficiary.isChild);
    

    const storedUserId = localStorage.getItem('userId');

    const fetchRefferedToInfoDetails = async () => {
      try {
        const res = await getReferredToInfoByFacilityReferralGroupId(referralMetaData.groupId);
        if(res) {
          const anyReferralStatusTrue = res.some((item:any) => item.referral_status_code === 'managed' || item.referral_status_code === 'rejected')
          if((res[0].facility_name.toLowerCase() !== decodedUserData.facility_name.toLowerCase()) || anyReferralStatusTrue) {
            setHideButton(true)
          }
          setReferredToData(res);
        }
      } catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
     }
    }
    
    useEffect(() => {
      const fetchReferredFromDetails = async () => {
        try {
          if (storedUserId) {
            const res = await getReferredFromInfoByReferralId(
              referralMetaData.childFacilityId,
            );
            if (res) {
              setDesignation(res[0].health_provider_name);
              setFacilityType(res[0].facility_type_name);
              setHPRId(res[0].v_hpr_id);
              setFirstName(res[0].f_name);
              setLastName(res[0].l_name);
              setFromCommentTest(res[0].referral_comment);
              setReferralDate(res[0].referral_date);
              setFacilityName(res[0].facility_name);
            }
          }
        } catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error);
        }
      };

      fetchReferredFromDetails();
      fetchRefferedToInfoDetails();
    }, [referralMetaData]);
          
    const handleManageReferral = async () => {
        try {
          const res = await getfacilityReferralStatus();
          if(res) {
            setReferralStatusOptions(res?.data)
            setShowModal(!showModal)
          }
        } catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
    }    
            
    const getStatusClassName = (statusName: any) => {
      switch (statusName) {
        case STATUS.PENDING:
          return STATUS_CLASSES.PENDING;
        case STATUS.TRANSFERRED:
          return STATUS_CLASSES.TRANSFERRED;
        case STATUS.REJECTED:
          return STATUS_CLASSES.REJECTED;
        case STATUS.MANAGED:
          return STATUS_CLASSES.MANAGED;
        case STATUS.EXPIRED:
          return STATUS_CLASSES.EXPIRED;
        default:
          return STATUS_CLASSES.DEFAULT;
      }
    };

    const handleSubmit = async (statusId: string, comment: string,status:string) => {
     const payload = {
          facilityRefId:referralMetaData.childFacilityId,
          referralStatusId:statusId,
          benefId: isChild ? childDetails?.benef_id : beneficiaryDetails?.benef_id,
          statusComment:comment,
          parentUserId:storedUserId,
        }

        try {
          const res = await changeReferralStatus(payload,status);
          if(res) {
            setShowModal(false);
            setHideButton(true);
            fetchRefferedToInfoDetails();
          }
        }
     catch (error:any) {
      errorLogger(error?.response?.data || error?.response || error);
    }        
    }
    
    return (
      <>
        <div className="overview_referral">
          {showModal && (
            <ManageReferralModal
              handleCloseModal={() => {setShowModal(false);}}
              showWarningModal={showModal}
              handleWarningModalBackButton={() => {setShowModal(false);}}
              handleFinalSubmit={handleSubmit}
              handleCommentChange={(newComment:string) => {setCommentText(newComment);}}
              referredStatus={referralStatusOptions}
              handleOptionChange={(id:any) => {setSelectedStatusId(id)}}
            />
          )}
          <div className="view-container">
            <BadgesComponent
              className="over-badge"
              badgeName="Referred From"
              variant="primary-1"
              badgeType="case5"
            />
            {decodedUserData?.user_designation_name ===
              FACILITY_COMMON_CONSTANTS.MOIC &&
              canCreateServices && (
                <div className="btn-container">
                  <Button
                    buttonName={'Refer Beneficiary'}
                    onClick={() => {navigate(FACILITY_NAVIGATIONS.FACILITY_REFERRAL);}}
                    colorType={'disabled'}
                    id={''}
                    disabled={hideButton || childDetails?.is_dead}
                    iconPosition={'left'}
                  />
                  <Button
                    buttonName={'Manage Referral'}
                    onClick={handleManageReferral}
                    colorType={'primary'}
                    id={''}
                    disabled={hideButton || childDetails?.is_dead}
                    iconPosition={'left'}
                  />
                </div>
              )}
          </div>
          <div className="overview-details">
            <div>
              <label className="overview-details-label">Facility Type</label>
              <div className="overview-details-value">
                {facilityType ? facilityType : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">
                Referred From Facility
              </label>
              <div className="overview-details-value">
                {facilityName ? facilityName : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">Date of Referral</label>
              <div className="overview-details-value">
                {referralDate ? dayjs(referralDate).format(dateFormate.dd_mm_yyyy) : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">HPR Id</label>
              <div className="overview-details-value">
                {hprId ? hprId : '-'}
              </div>
            </div>
            <div>
              <label className="overview-details-label">
                Health Provider Name
              </label>
              <div className="overview-details-value">{`${firstName} ${lastName}`}</div>
            </div>
            <div>
              <label className="overview-details-label">
                Health Provider Designation
              </label>
              <div className="overview-details-value">
                {designation ? designation : '-'}
              </div>
            </div>
          </div>
          <div className="overview-details">
            <div>
              <label className="overview-details-label">
                Comment Added on {dayjs(referralDate).format(dateFormate.dd_mm_yyyy)}
              </label>
              <div className="overview-details-value">
                {fromCommentText ? fromCommentText : '-'}
              </div>
            </div>
          </div>
        </div>
        {referredToData &&
          referredToData?.map((data, index) => {
            return (
              <div className="pnc-delivery-details" key={index}>
                <BadgesComponent
                  className="over-badge"
                  badgeName="Referred To"
                  variant="primary-1"
                  badgeType="case5"
                />
                <div className="overview-details">
                  <div>
                    <label className="overview-details-label">
                      Service Type
                    </label>
                    <div className="overview-details-value">
                      {data?.service_type_name ? data?.service_type_name : '-'}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">
                      Reason for Referral
                    </label>
                    <div className="overview-details-value">
                      {data?.complication_names
                        ? data?.complication_names.join(',')
                        : '-'}
                    </div>
                  </div>
                 {data?.complication_names?.includes('Other') && <div>
                    <label className="overview-details-label">
                      Other Reason
                    </label>
                    <div className="overview-details-value">
                      {data?.other_complication_details
                        ? data?.other_complication_details
                        : '-'}
                    </div>
                  </div>}
                  <div>
                    <label className="overview-details-label">
                      Expected Date of Visit
                    </label>
                    <div className="overview-details-value">
                      {data?.visit_date
                        ? dayjs(data?.visit_date).format(dateFormate.dd_mm_yyyy)
                        : '-'}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">
                      Date of Referral
                    </label>
                    <div className="overview-details-value">
                      {data?.visit_date
                        ? dayjs(data?.referral_date).format(dateFormate.dd_mm_yyyy)
                        : ''}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">
                      Time of Referral
                    </label>
                    <div className="overview-details-value">
                      {referralDate
                        ? dayjs(referralDate).format(dateFormate.hh_mm_A)
                        : '-'}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">
                      Sub District
                    </label>
                    <div className="overview-details-value">
                      {data?.sub_district_name ? data?.sub_district_name : '-'}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">Block</label>
                    <div className="overview-details-value">
                      {data?.block_name ? data?.block_name : '-'}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">ULB</label>
                    <div className="overview-details-value">
                      {data?.ulb_name ? data.ulb_name : '-'}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">Village</label>
                    <div className="overview-details-value">
                      {data?.village_name ? data?.village_name : '-'}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">Ward</label>
                    <div className="overview-details-value">
                      {data?.ward_name ? data?.ward_name : '-'}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">
                      Facility Type
                    </label>
                    <div className="overview-details-value">
                      {data?.facility_type_name
                        ? data?.facility_type_name
                        : '-'}
                    </div>
                  </div>
                  <div>
                    <label className="overview-details-label">
                      Facility Name
                    </label>
                    <div className="overview-details-value">
                      {data?.facility_name ? data?.facility_name : '-'}
                    </div>
                  </div>

                  <div>
                    <label className="overview-details-label">
                      Referral Status
                    </label>
                    <div
                      className={`overview-details-status ${getStatusClassName(data?.referral_status_name)}`}
                    >
                      {data?.referral_status_name
                        ? data?.referral_status_name
                        : '-'}
                    </div>
                  </div>
                </div>
                {data?.status_update_comment !== '' &&
                data?.status_update_comment !== null ? (
                  <div className="overview-details">
                    <div>
                      <label className="overview-details-label">
                        Comment Added on{' '}
                        {dayjs(data?.referral_date).format(dateFormate.dd_mm_yyyy)}
                      </label>
                      <div className="overview-details-value">
                        {data?.status_update_comment
                          ? data?.status_update_comment
                          : '-'}
                      </div>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            );
          })}
      </>
    );
  }
  
  export default ReferralChildView
